module.exports = __webpack_public_path__ + "img/stout_shield.84ec5796.png";